webpackJsonp([36733297554888],{

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    margin-bottom: 160px;\n  '], ['\n    margin-bottom: 160px;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n      margin-bottom: ', ';\n    '], ['\n      margin-bottom: ', ';\n    ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n      padding: 0 0 0 30px;\n    '], ['\n      padding: 0 0 0 30px;\n    ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n        padding-right: 100px;\n        padding-left: 80px;\n      '], ['\n        padding-right: 100px;\n        padding-left: 80px;\n      ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n      max-width: 100%;\n      //margin-left: -100px;\n    '], ['\n      max-width: 100%;\n      //margin-left: -100px;\n    ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMarkdown = __webpack_require__(132);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(6);
	
	var _shared = __webpack_require__(7);
	
	var _FacebookTags = __webpack_require__(108);
	
	var _FacebookTags2 = _interopRequireDefault(_FacebookTags);
	
	var _components = __webpack_require__(376);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	/* Not sure why 'FacebookTags' is not working if included in above import along with Container and SeoTags */
	
	
	var sp = _styles.theme.sp,
	    colors = _styles.theme.colors;
	
	
	var Wrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'BlogPage__Wrapper'
	})(['background:#f8fbff;margin-bottom:100px;', ';'], _styles.media.laptop(_templateObject));
	
	var Content = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'BlogPage__Content'
	})(['font-size:20px;font-weight:400;margin:0 auto;h2{margin-bottom:', ';}h3{margin-bottom:', ';}p,ul,ol{counter-reset:item;line-height:1.4;font-weight:400;margin-bottom:', ';', ';}ol,ul{padding:0;', ';}ul li{position:relative;list-style:none;padding-left:40px;margin-bottom:', ';&::before{position:absolute;top:15px;left:0;width:20px;height:2px;background-color:', ';content:\'\';}}ol li{position:relative;counter-increment:item;list-style:none;padding-left:40px;margin-bottom:', ';&::before{position:absolute;top:0;left:0;content:counters(item,\'\') \'.\';color:', ';width:20px;}}a{transition:all 0.3s;text-decoration:none;color:', ';}a:hover{color:', ';}caption{display:inline-block;width:100%;text-align:center;margin-bottom:', ';font-size:14px;font-style:italic;font-weight:500;color:', ';}blockquote{margin:', ' 0 100px;border-left:', ' solid ', ';p{margin:0;padding-right:40px;padding-left:40px;width:100%;font-size:24px;line-height:36px;font-style:italic;font-weight:500;color:', ';', ';}}.embed-container{margin-bottom:', ';}img{display:block;max-width:100%;margin-bottom:', ';', ';}'], sp.xl, sp.m, sp.xl, _styles.media.tablet(_templateObject2, sp.xxl), _styles.media.tablet(_templateObject3), sp.s, colors.blue, sp.s, colors.blue, colors.blue, colors.blue, sp.xxl, colors.grey, sp.max, sp.xxs, colors.blue, colors.grey, _styles.media.tablet(_templateObject4), sp.xxl, sp.xxl, _styles.media.desktop(_templateObject5));
	
	function BlogPage(_ref) {
	  var data = _ref.data;
	  var heading = data.heading,
	      slug = data.slug,
	      content = data.content,
	      headerBackgroundImage = data.headerBackgroundImage,
	      categories = data.categories,
	      seoTitle = data.seoTitle,
	      seoKeywords = data.seoKeywords,
	      seoDescription = data.seoDescription;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(_shared.SeoTags, {
	      title: seoTitle,
	      keywords: seoKeywords,
	      description: seoDescription && seoDescription.seoDescription
	    }),
	    _react2.default.createElement(_FacebookTags2.default, {
	      fbUrl: ("https://markettap.com") + '/tapd-in/' + slug + '/',
	      fbTitle: seoTitle,
	      fbDescription: seoDescription && seoDescription.seoDescription,
	      fbImage: 'http:' + headerBackgroundImage.responsiveResolution.src
	    }),
	    _react2.default.createElement(_components.Header, {
	      image: headerBackgroundImage,
	      heading: heading,
	      categories: categories,
	      slug: slug
	    }),
	    _react2.default.createElement(
	      _shared.Container,
	      { narrow: true },
	      _react2.default.createElement(
	        Content,
	        null,
	        _react2.default.createElement(_reactMarkdown2.default, { source: content.content, escapeHtml: false })
	      )
	    )
	  );
	}
	
	BlogPage.propTypes = {
	  data: _propTypes2.default.shape({}).isRequired
	};
	
	exports.default = BlogPage;
	module.exports = exports['default'];

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    padding: ', ' 15px;\n  '], ['\n    padding: ', ' 15px;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    background-size: cover;\n    background-position: left;\n    background-image: url(\'', '\');\n    background-repeat: no-repeat;\n    height: 600px;\n  '], ['\n    background-size: cover;\n    background-position: left;\n    background-image: url(\'', '\');\n    background-repeat: no-repeat;\n    height: 600px;\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(6);
	
	var _mixins = __webpack_require__(17);
	
	var _mixins2 = _interopRequireDefault(_mixins);
	
	var _shared = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	// Why do you need this? It seems to work without it???
	
	
	var sp = _styles.theme.sp,
	    colors = _styles.theme.colors;
	
	
	var BannerContainer = /*#__PURE__*/(0, _styledComponents2.default)(_shared.Container).withConfig({
	  displayName: 'Header__BannerContainer'
	})(['display:flex;flex-direction:column;justify-content:space-between;z-index:1;height:100%;padding:40px 15px;text-align:center;', ';'], _styles.media.desktop(_templateObject, sp.max));
	
	var BlogCategoryWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Header__BlogCategoryWrapper'
	})(['display:flex;justify-content:center;']);
	
	var BlogCategory = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Header__BlogCategory'
	})(['padding:0 5px;a{display:inline-block;transition:all 0.3s;border:2px solid ', ';border-radius:15px;padding:0 20px;height:30px;font-size:14px;line-height:24px;font-weight:600;color:', ';text-decoration:none;&:hover{border:2px solid ', ';}}'], colors.blue, colors.offWhite, colors.offWhite);
	
	var BannerImage = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Header__BannerImage'
	})(['position:absolute;top:-20px;left:-20px;background-size:cover;background-position:left;background-image:url(\'', '\');background-repeat:no-repeat;height:640px;width:calc(100% + 40px);filter:blur(10px);'], function (props) {
	  return props.src;
	});
	
	var StyledHeader = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Header__StyledHeader'
	})(['display:flex;position:relative;justify-content:center;flex-direction:column;position:relative;overflow:hidden;margin-bottom:', ';height:320px;&::after{position:absolute;top:0;right:0;bottom:0;left:0;content:\'\';background-color:rgba(43,88,153,0.7);*/}', ';h1{', ';margin:0 auto;max-width:600px;color:', ';}'], sp.max, _styles.media.tablet(_templateObject2, function (props) {
	  return props.src;
	}), _mixins2.default.heroText, colors.white);
	
	function Header(props) {
	  var heading = props.heading,
	      image = props.image,
	      slug = props.slug,
	      categories = props.categories;
	
	  var breadcrumbs = [{
	    name: 'Home',
	    link: '/'
	  }, {
	    name: "Tap'd in",
	    link: '/tapd-in'
	  }, {
	    // name: heading,
	    name: 'Article',
	    link: '/tapd-in/' + slug
	  }];
	  return _react2.default.createElement(
	    StyledHeader,
	    null,
	    _react2.default.createElement(BannerImage, { src: image.responsiveResolution.src }),
	    _react2.default.createElement(
	      BannerContainer,
	      null,
	      _react2.default.createElement(_shared.Breadcrumbs, { breadcrumbs: breadcrumbs, light: true }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        heading
	      ),
	      _react2.default.createElement(
	        BlogCategoryWrapper,
	        null,
	        !!categories && categories.map(function (category) {
	          return _react2.default.createElement(
	            BlogCategory,
	            { key: category.id },
	            _react2.default.createElement(
	              'a',
	              { href: '/tapd-in/category/' + category.slug },
	              category.title
	            )
	          );
	        })
	      )
	    )
	  );
	}
	
	Header.propTypes = {
	  heading: _propTypes2.default.string.isRequired,
	  slug: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.shape({}).isRequired,
	  categories: _propTypes2.default.arrayOf({}).isRequired
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Header = __webpack_require__(374);
	
	var _Header2 = _interopRequireDefault(_Header);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Header2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Header = undefined;
	
	var _Header = __webpack_require__(375);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Header = _Header2.default;

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BlogPage = __webpack_require__(373);
	
	var _BlogPage2 = _interopRequireDefault(_BlogPage);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _BlogPage2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BlogPage = __webpack_require__(377);
	
	var _BlogPage2 = _interopRequireDefault(_BlogPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Blog(_ref) {
	  var pathContext = _ref.pathContext;
	
	  return _react2.default.createElement(_BlogPage2.default, { data: pathContext });
	}
	
	Blog.propTypes = {
	  pathContext: _propTypes2.default.shape({}).isRequired
	};
	
	exports.default = Blog;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-js-d02d0701e7ec3dd06530.js